import * as Occupancy from "@ssc-booking/api-contracts/src/occupancy"
import * as A from "fp-ts/Array"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"

export function encodeGuests(guest: Occupancy.Occupancy) {
    return `A${guest.adults}-K${guest.kids}`
}
export function decodeGuests(encodedGuest: string): Occupancy.Occupancy {
    const removeSymbol = (symbol: string) => (value: string) => value.replace(symbol, "")
    const maybeParse = (s: string): O.Option<number> => {
        const parsed = parseInt(s, 10)
        return isNaN(parsed) ? O.none : O.some(parsed)
    }

    const decodeSymbol = (symbol: string, values: string[]): number =>
        F.pipe(
            A.findFirst((x: string) => x.startsWith(symbol))(values),
            O.map(removeSymbol(symbol)),
            O.chain(maybeParse),
            O.fold(
                () => 0,
                (n) => n,
            ),
        )

    try {
        const parts = encodedGuest.split("-")
        return Occupancy.of(decodeSymbol("A", parts), decodeSymbol("K", parts))
    } catch {
        return Occupancy.of(2, 0)
    }
}
